module.exports = "/roster/directives/rosterTableColumn-ebb9d2.html";